import React from 'react';
import { connect } from 'react-redux';

import { Button, Col, Row, Popconfirm } from 'antd';

import AddAddressDrawer from '../../user/add-address-drawer';

import { 
	_postAddAddressToQuote,
	_postDeleteAddress
} from '../../../services';
import {
	setQuotationActiveShipping,
	setQuotationUserNewAddress
} from '../actions';

class UserAddresses extends React.Component{
	render(){

		const { title, addresses, selectedAddressId } = this.props;

		// if( !addresses || addresses.length === 0 ){
		// 	return null;
		// }

		return (
			<div>
				<Row type="flex" gutter={8}>
					<Col>
						<h4>{title}</h4>
					</Col>
					{!this.props.punchoutCart && (
						<Col>
							<Button type="primary" size="small" onClick={this.onClickAddAddress}>+ address</Button>
						</Col>
					)}
				</Row>


				{( !addresses || addresses.length === 0 ) && (
					<div style={{ height: 106, width: "100%" }}/>
				)}

				{addresses && addresses.length > 0 && addresses.map(
					address => (
						<div 
							key={address._id} 
							onClick={ () => this.props.onSelectAddress( address) } 
							
							className="address-container">
		
							<div className={`address ${address._id.toString() === selectedAddressId.toString()?'selected':''}`}>
								
								{/* Singapore | Name */}
								<div className="address-header layout-row layout-align-start-center">
									<div className="flag-shadow flag-container layout-row layout-align-start-center">
										<img alt="flags" src={`https://storage.googleapis.com/eezee-storage/flags/${address.country}.png`} /> 
									</div>
									<span style={{marginLeft: 36}}>{address.name.length >= 17? `${address.name.substring(0,14)}...`: address.name} - {address.hp}</span>
								</div>
		
								<div className="address-raw">{address.address} {address.unit}</div>
								<div className="address-raw" style={{display:"flex", justifyContent:"space-between"}}>
									<span>{address.companyName}</span>

									{!this.props.punchoutCart && (
										<Popconfirm title="Confirm remove address?" 
											onConfirm={() => this.deleteAddress(address)} 
											okText="Yes" 
											cancelText="No">
											<Button 
												size="small" 
												type="danger"
												>delete</Button>
										</Popconfirm>
									)}
								</div>

								{/* <div onClick={ (e) => {
										e.stopPropagation();
										this.onClickEdit( address )
									}} className="address-edit">Edit</div> */}

							</div>
						</div>
					)
				)}

				{ this.state.drawerOpened && (
					<AddAddressDrawer 
						user={this.props.user}
						drawerOpened={ this.state.drawerOpened }
						onClose={ this.onCloseAddressDrawer }
						handleAddAddress={ this.handleAddAddress } />
				)}
				
			</div>
		)
	}

	state = {
		drawerOpened: false
	}

	deleteAddress = (address) =>{
		console.log(address);

		const userId = this.props.user._id

		_postDeleteAddress({ userId, address })
		.then( res=> {
			this.props.setQuotationUser(res.data.user);
		})
		.catch(err=> console.log(err))

	}
	
	handleAddAddress = ( address ) => {

		const userId = this.props.user._id;
		const cartId = this.props.cart._id;
		
		_postAddAddressToQuote({ userId, quotationId: cartId, address })
			.then( res => {
				// add address to user
				if ( res.data.makeAddress ){
					this.props.setQuotationActiveShipping( res.data.address );	
				}
				
				this.props.setQuotationUserNewAddress( res.data.address );
				
				this.onCloseAddressDrawer();
				
			})
			.catch( e => {
				// alert( JSON.stringify( Object.keys( e ) ) );
				// alert( JSON.stringify( e.config ) );
				// alert( JSON.stringify( e.response ) );
			});
			
	}


	onClickAddAddress = () => {
		this.setState({
			drawerOpened: true
		})
	}

	onClickEdit = () => {
		// alert('edit');
	}

	onCloseAddressDrawer = () => {
		this.setState({
			drawerOpened: false
		})
	}
	

}

export default connect(
	state => ({
		punchoutCart: state.quotation.cart && state.quotation.cart.punchoutCart
	}),
	dispatchEvent => ({
		setQuotationActiveShipping: ( address ) => dispatchEvent( setQuotationActiveShipping(address) ),
		setQuotationUserNewAddress: ( address) => dispatchEvent( setQuotationUserNewAddress(address) )
	})
)(UserAddresses);


// WEBPACK FOOTER //
// ./src/components/quotation/add-quotation-modal/user-addresses.js